// extracted by mini-css-extract-plugin
export default {"wrap":"Label_wrap__k7F3Z","label":"Label_label__OB7j6","value":"Label_value__5U+HU"};